import { render, staticRenderFns } from "./milestone-form-footer-plan.vue?vue&type=template&id=6adb971d&scoped=true&"
import script from "./milestone-form-footer-plan.vue?vue&type=script&lang=ts&"
export * from "./milestone-form-footer-plan.vue?vue&type=script&lang=ts&"
import style0 from "./milestone-form-footer-plan.vue?vue&type=style&index=0&id=6adb971d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adb971d",
  null
  
)

export default component.exports